import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';
import styles from './FieldService.module.scss';

const FieldService = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'payment-form-service',
    defaultMessage: 'Service'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta] = useField<string>({name: 'service'});

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      id={field.name}
      label={
        <div className={styles.labelContainer}>
          <span>{labelText}</span>
        </div>
      }
      defaultValue={field.value}
      placeholder={placeholder}
    />
  );
};

export default FieldService;
